import BearContext from "contexts/BearContext";
import { useContext } from "react";

const useBear = () => useContext(BearContext);

export default useBear;
